import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalNewInvitationService {
  private CLIENTE = environment.CLIENTE;

  public modal: Subject<boolean> = new Subject<boolean>();
  public reloadGuests: Subject<boolean> = new Subject<boolean>();
  public visitId: Subject<string> = new Subject<string>();

  constructor(private readonly http: HttpClient) {}

  open(): void {
    this.modal.next(true);
  }

  close(): void {
    this.modal.next(false);
  }

  reloadGetGuests(status: boolean): void {
    this.reloadGuests.next(status);
  }

  visitIdForModal(id: string): void {
    this.visitId.next(id);
  }

  /**
   * Invit a new guess
   * @param visitId visit information
   */
  public addGuessVisit(data: any, id: string): Observable<any> {
    const path = this.CLIENTE.VISIT_GUESS.replace('{visitId}', id);
    return this.http.patch<any>(`${path}`, data);
  }
}
